var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.name_project === 'ttttt')?_c('LoginTrav'):_c('LoginAll')}
var staticRenderFns = []

export { render, staticRenderFns }